module.exports = __webpack_public_path__ + "img/content_make4.e204d887.png";